import React from "react"
export default function Input(props) {
    return <input {...props} />
}



// WEBPACK FOOTER //
// ./src/ui/legacy/Input.js